/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  display: inline-block;
  width: 100%;
}
:host #parent {
  height: 100%;
  font-weight: 600;
  display: flex;
  flex-direction: column;
  contain: paint;
}
:host #parent #symbol {
  padding-top: 0.75rem;
  height: 1%;
  flex: 1;
}
:host #parent #symbol davinci-icon-ref {
  width: 100%;
  height: 100%;
}
:host #parent #text {
  max-height: 135px;
  padding: 0.5rem 1rem 1rem;
  margin: 0 auto;
  max-height: 100%;
  max-width: 100%;
  font-size: 2rem;
}

:host([status=warning]) {
  background-color: var(--davinci-color-warning-light, );
  color: var(--davinci-color-warning, );
}
:host([status=warning]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-warning, );
}

@-webkit-keyframes critical_color {
  from {
    background-color: var(--davinci-color-error-light, );
    color: var(--davinci-color-error, );
  }
  to {
    background-color: var(--davinci-color-error, );
    color: #FFFFFF;
    color: var(--davinci-color-background-container, #FFFFFF);
  }
}

@keyframes critical_color {
  from {
    background-color: var(--davinci-color-error-light, );
    color: var(--davinci-color-error, );
  }
  to {
    background-color: var(--davinci-color-error, );
    color: #FFFFFF;
    color: var(--davinci-color-background-container, #FFFFFF);
  }
}
@-webkit-keyframes critical_fill {
  from {
    fill: var(--davinci-color-error, );
  }
  to {
    fill: #FFFFFF;
    fill: var(--davinci-color-background-container, #FFFFFF);
  }
}
@keyframes critical_fill {
  from {
    fill: var(--davinci-color-error, );
  }
  to {
    fill: #FFFFFF;
    fill: var(--davinci-color-background-container, #FFFFFF);
  }
}
:host([status=error]) {
  background-color: var(--davinci-color-error-light, );
  color: var(--davinci-color-error, );
}
:host([status=error]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-error, );
}

:host([status=critical]) {
  -webkit-animation: critical_color 600ms ease-in-out infinite alternate;
          animation: critical_color 600ms ease-in-out infinite alternate;
}
:host([status=critical]) #symbol > davinci-icon-ref {
  -webkit-animation: critical_fill 600ms ease-in-out infinite alternate;
          animation: critical_fill 600ms ease-in-out infinite alternate;
}

:host([status=ok]) {
  background-color: var(--davinci-color-success-light, );
  color: var(--davinci-color-success, );
}
:host([status=ok]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-success, );
}

:host([status=unknown]) {
  background-color: var(--davinci-color-unknown-light, );
}
:host([status=unknown]) #symbol > davinci-icon-ref {
  fill: var(--davinci-color-unknown, );
}

:host {
  background-color: #FFFFFF;
  background-color: var(--davinci-color-background-container, #FFFFFF);
}
:host #symbol > davinci-icon-ref {
  fill: var(--davinci-color-text-on-background, );
}

:host([header-icon=settings]) #parent {
  border-color: #737F85;
  border-color: var(--davinci-color-outline-on-container-edit, #737F85);
}

:host([hidden]) {
  display: none;
}`;
export { style };
